module.exports = __webpack_public_path__ + "static/Nuke-5a8887e0009c0a800c6954aafe25ed58.png";